<template>
  <div class="container my-2 p-0">
    <b-tabs class="clinic-sub-tabs" justified lazy>
      <b-tab index="recipes" title="Talonarios XML">
        <clinic-xml-recipes></clinic-xml-recipes>
      </b-tab>
      <b-tab index="pharmaceuticals" title="Fármacos">
        <clinic-pharmaceuticals></clinic-pharmaceuticals>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss">
.clinic-prescriptions {}
</style>
